<div class="admin-menu nav-item dropdown size-button-chat" ngbDropdown [autoClose]="'outside'" container="body">
  <button 
    type="button" 
    class="btn btn-light btn-icon waves-effect border-chat"
    ngbDropdownToggle 
    (click)="toggleDropdown()">
    
    <i class="bx bx-message topbar-icon-size" aria-hidden="true"></i>
    
    <span 
      class="badge bg-success rounded-pill badge-chat" 
      *ngIf="messageNoReadQty > 0">
      {{ messageNoReadQty }}
    </span>
  </button>

  <!-- MENÚ -->
  <div id="chatDropdown" class="dropdown-menu dropdown-menu-end p-0 chat-menu" ngbDropdownMenu>
    <div class="chat-panel">
      <!-- LEFT -->
      <aside class="chat-left">
        <div class="left-top border-bottom p-3">
          <div class="input-group input-group-sm me-2">
            <span class="input-group-text"><i class="bx bx-search"></i></span>
            <input type="text"
                  class="form-control"
                  [placeholder]="'carrier.chat_service.search_driver' | translate"
                  [(ngModel)]="searchTerm"
                  (ngModelChange)="updateFilter()">
            <button *ngIf="searchTerm"
                    type="button"
                    class="btn btn-outline-secondary"
                    (click)="clearSearch()">
              <i class="bx bx-x"></i>
            </button>
          </div>

          <div class="d-flex gap-2 mt-2">
            <button class="btn btn-soft-primary btn-sm"
                    (click)="getAllDriversInCarrier()"
                    [disabled]="isLoadingRefresh"
                    [ngbTooltip]="'carrier.chat_service.reload_driver' | translate">
              <i class="bx bx-refresh"></i>
            </button>

            <button class="btn btn-soft-secondary btn-sm"
                    (click)="onClickNotificacionEnable()"
                    [ngbTooltip]="'carrier.chat_service.notification_sound_on' | translate">
              <i class="bx" [ngClass]="isNotificacionEnable ? 'bx-bell' : 'bx-bell-off'"></i>
            </button>
          </div>
        </div>

        <div class="left-list">
          <button class="chat-item"
                  *ngFor="let item of allDrivers; trackBy: trackByDriver"
                  (click)="getChatDataAndDetails(item.row.Col1); selectedDriver = item.row.Col1"
                  [class.active]="selectedDriver === item.row.Col1">
            <img class="avatar" [src]="item.row.Col4 || 'assets/img/avatars/default-avatar.png'">
            <div class="meta">
              <div class="name text-truncate">{{ item.row.Col3 }}</div>
              <div class="code text-muted">{{ item.row.Col2 }}</div>
            </div>
            <span class="badge bg-success rounded-pill ms-auto"
                  *ngIf="getChatValue(item.row.Col1)">{{ getChatValue(item.row.Col1) }}</span>
          </button>
        </div>
      </aside>

      <!-- RIGHT -->
      <section class="chat-right">
        <header class="chat-header">
          <div class="d-flex align-items-center gap-2">
            <!-- <div class="avatar-sm rounded-circle bg-light d-flex align-items-center justify-content-center">
              <i class="bx bx-user"></i>
            </div>
            <div class="fw-semibold">
              {{ selectedDriverName || ('carrier.chat_service.select_driver' | translate) }}
            </div> -->
          </div>
          <button type="button" class="btn btn-ghost-secondary btn-sm" (click)="onChatClose()">
            <i class="bx bx-x"></i>
          </button>
        </header>

        <div class="chat-messages" #msgScroller>
          <ng-container *ngIf="selectedChat?.length; else emptyState">
            <div *ngFor="let chat of selectedChat; trackBy: trackByChat"
                class="bubble"
                [class.me]="chat.sender==='CARRIER' && chat.operatorName===selectedOperatorName">
              <div class="bubble-body" *ngIf="chat.message">{{ chat.message }}</div>
              <audio *ngIf="chat.fileName" [src]="chat.fileName" controls></audio>
              <div class="bubble-meta">
                {{ chat.timestamp | date: dateFormat }} ·
                {{ chat.timestamp | date:_localizationService?.localeData.timeFormat }}
              </div>
            </div>
          </ng-container>

          <ng-template #emptyState>
            <div class="empty"></div>
          </ng-template>
        </div>

        <footer class="chat-input" *ngIf="selectedDriver !== ''">
          <input type="text"
                class="form-control"
                [(ngModel)]="newMessage"
                [placeholder]="'carrier.chat_service.type_your_message' | translate"
                [disabled]="recording || isSending"
                (keyup.enter)="newMessage.trim() && !isSending && sendChatMessage(selectedDriver, newMessage)">

          <div class="d-flex align-items-center gap-2">
            <button class="btn btn-primary"
                    (click)="sendChatMessage(selectedDriver, newMessage)"
                    [disabled]="!newMessage?.trim() || isSending">
              <i class="bx bx-send"></i>
            </button>

            <button class="btn btn-outline-secondary"
                    (click)="startRecording()"
                    [disabled]="recording || !!newMessage">
              <i class="bx bx-microphone"></i>
            </button>

            <button class="btn btn-outline-danger" (click)="discardRecording()" *ngIf="recording">
              <i class="bx bx-trash"></i>
            </button>

            <div *ngIf="recording" class="small text-muted">
              {{ formatTime(seconds) }} · {{ 'carrier.chat_service.recording_audio' | translate }}
            </div>

            <button class="btn btn-success" (click)="stopRecording()" *ngIf="recording">
              <i class="bx bx-send"></i>
            </button>
          </div>
        </footer>
      </section>
    </div>
  </div>

</div>
